import React, { useState } from "react";
import { CountryDropdown } from "react-country-region-selector";
import { useSelector } from "react-redux";
import DebouncedInput from "./debounced-input";
import { APPLICATION_LIST } from "../../../services";

interface Props {
    columnName: any;
    handleChange: any;
}

function CmpFilter(props: Props) {
    const { columnName, handleChange } = props;
    const [value, setValue] = useState("");

    const onChange = (val: any) => {
        setValue(val);
        handleChange(val, columnName);
    };

    const whiteListedCountry = useSelector((state: any) => state.users.currentUser.country);
    const currentUser = useSelector((state: any) => state.users.currentUser);

    return (
        <>
            {columnName === "country" ? (
                currentUser.userType === 1 ? (
                    <CountryDropdown
                        classes="form-control mb-0"
                        valueType="short"
                        value={value}
                        onChange={(val: any) => {
                            onChange(val);
                        }}
                        whitelist={whiteListedCountry}
                        defaultOptionLabel="Select All"
                    />
                ) : (
                    <CountryDropdown
                        classes="form-control mb-0"
                        valueType="short"
                        value={value}
                        onChange={(val: any) => {
                            onChange(val);
                        }}
                        defaultOptionLabel="Select All"
                    />

                    // <CountryDropdown
                    //     classes="form-control mb-0"
                    //     valueType="short"
                    //     value={value}
                    //     onChange={(val: any) => onChange(val)}
                    // />
                )
            ) : columnName === "appName" ? (
                <select
                    className={`form-control mb-0`}
                    onChange={(e) => {
                        e.persist();
                        onChange(e.target.value);
                    }}
                >
                    <option value="">Select All</option>
                    {APPLICATION_LIST.map((option, index) => {
                        return (
                            <option key={index} value={option.value}>
                                {option.text}
                            </option>
                        );
                    })}
                </select>
            ) : (
                <DebouncedInput
                    type="text"
                    value={value}
                    onChange={(val) => {
                        onChange(val);
                    }}
                    placeholder="Search..."
                />
            )}
        </>
    );
}

export default CmpFilter;
